import loadable from '@loadable/component';

const ListLoadable = loadable(() => import('./List'));

export default ListLoadable;
